import { Link } from 'react-router-dom';
import { articles } from '@/mocks/news';

export default function NewsGrid() {
  const gridArticles = articles.slice(0, 9);

  return (
    <div className="w-full" data-product-shop>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {gridArticles.map((article, index) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src={article.imageUrl}
                alt={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                title={`${article.title} - 51黑料网`}
              />
              {article.isHot && (
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                  热门
                </span>
              )}
              {index === 0 && (
                <span className="absolute top-3 right-3 px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                  最新
                </span>
              )}
            </div>
            <div className="p-4">
              <div className="flex items-center gap-2 mb-2">
                <span className="text-xs text-primary-500 font-medium">
                  {article.category}
                </span>
                <span className="text-xs text-secondary-400">
                  {article.date}
                </span>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 line-clamp-2 leading-snug mb-2 group-hover:text-primary-500 transition-colors">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-4 mt-3 pt-3 border-t border-background-100">
                <span className="text-xs text-secondary-500">
                  <i className="ri-eye-line mr-1"></i>
                  {article.views.toLocaleString()}
                </span>
                <span className="text-xs text-secondary-500">
                  <i className="ri-chat-3-line mr-1"></i>
                  {article.comments.toLocaleString()}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}